var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @desc grid
 */
import * as lodash from '../../utils/lodash';
import { Group, Rect, Line, createText } from '../../element';
import { XAxis, YAxis } from '../axis';
import CoordCartesian from '../../coord/cartesian/index';
import { ComponentModel, renderModel } from '../../model';
import normalizeToArray from '../../utils/normalizeToArray';
import { getPlotInfoAtPoint } from '../../utils/plot';
/**
 * default
 */
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'grid';
        return _this;
    }
    Grid.prevProcessOption = function (option) {
        option.grid = normalizeToArray(option.grid || {});
        option.series = option.series.map(function (seriesOption) {
            return lodash.assign({
                xAxis: 0,
                yAxis: 0,
            }, seriesOption);
        });
    };
    Grid.prototype.getDefaultOption = function (rawOption) {
        return {
            background: 'none',
            adjustAxisPosition: true,
            facet: 0,
            quadrant: (rawOption === null || rawOption === void 0 ? void 0 : rawOption.quadrant) && {
                labels: {},
                // colors: {},
                areaFillColors: {},
                textStyle: {
                    color: '#999999',
                    fontSize: 12,
                },
                crosshairs: {
                    lineStyle: {
                        stroke: '#6E748E',
                        lineWidth: 1,
                    },
                },
            },
        };
    };
    Grid.prototype.getInitialState = function () {
        return {
            top: 0,
            left: 0,
            width: 0,
            height: 0,
            bottom: 0,
            right: 0,
            outerRect: { top: 0, right: 0, left: 0, bottom: 0 },
        };
    };
    Grid.prototype.init = function () {
        var _this = this;
        this.initAxisModels();
        this._clipPath = new Rect({
            draggable: true,
            fill: '#ffffff',
            getDragOffset: function () {
                return { x: 0, y: 0 };
            },
            onEvent: function (event) {
                var _a = event, x = _a.x, y = _a.y;
                var _b = getPlotInfoAtPoint(_this, x, y), points = _b.points, dataIndex = _b.dataIndex;
                _this.handleUIEvent(event, 'plot', { target: _this, points: points, dataIndex: dataIndex });
            },
        });
        var renderer = this.chart.getRenderInstance();
        renderer.addEventElement(this._clipPath);
    };
    Grid.prototype.initAxisModels = function () {
        var _this = this;
        var option = this.chart.getOption();
        var xAxis = option.xAxis, yAxis = option.yAxis;
        this.xAxis = [];
        this.yAxis = [];
        xAxis.forEach(function (axis, index) {
            if (axis.grid === _this.extraInfo.gridIndex) {
                var childModel = new XAxis('xAxis', axis, _this.chart, { axis: 'xAxis', index: index }, _this);
                _this.xAxis.push(childModel);
                option.xAxis[index] = childModel.getOption();
            }
        });
        yAxis.forEach(function (axis, index) {
            if (axis.grid === _this.extraInfo.gridIndex) {
                var childModel = new YAxis('yAxis', axis, _this.chart, { axis: 'yAxis', index: index }, _this);
                _this.yAxis.push(childModel);
                option.yAxis[index] = childModel.getOption();
            }
        });
        this.xAxis.forEach(function (axis) { return axis.init(); });
        this.yAxis.forEach(function (axis) { return axis.init(); });
    };
    Grid.prototype.getAllAxis = function () {
        return [].concat(this.xAxis, this.yAxis);
    };
    Grid.prototype.getCoordinate = function (seriesOption) {
        var xAxisIndex = seriesOption.xAxis, yAxisIndex = seriesOption.yAxis;
        var xAxis = this.xAxis.filter(function (axis) { return axis.extraInfo.index === xAxisIndex; })[0];
        var yAxis = this.yAxis.filter(function (axis) { return axis.extraInfo.index === yAxisIndex; })[0];
        return new CoordCartesian(xAxis, yAxis);
    };
    Grid.prototype.getDependentSeries = function () {
        return this.chart
            .getSeriesByDependency('coord')
            .filter(function (seriesModel) {
            return seriesModel.option.coord === 'cartesian2d';
        });
    };
    Grid.prototype.beforeRender = function () {
        var _a = this.chart.getFacetContentBox(this.option.facet), top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom, width = _a.width, height = _a.height;
        this.setState({
            top: top,
            left: left,
            right: right,
            bottom: bottom,
        });
        var labelSizeMap = {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        };
        var hasDepend = this.getDependentSeries().length > 0;
        this._clipPath.setAttr({ display: hasDepend });
        if (this.option.adjustAxisPosition) {
            var axisList = [].concat(this.xAxis, this.yAxis);
            axisList.forEach(function (axis) {
                axis.initScale();
                var _a = axis.getLabelAreaSize(), side = _a.side, size = _a.size;
                if (lodash.isNumber(size)) {
                    labelSizeMap[side] += size;
                }
            });
        }
        this.setState({
            top: top + labelSizeMap.top,
            left: left + labelSizeMap.left,
            right: right - labelSizeMap.right,
            bottom: bottom - labelSizeMap.bottom,
            width: width - labelSizeMap.left - labelSizeMap.right,
            height: height - labelSizeMap.top - labelSizeMap.bottom,
            outerRect: { top: top, left: left, right: right, bottom: bottom },
        });
        this._clipPath.setAttr({
            x: this.state.left + 0.5,
            y: this.state.top + 0.5,
            width: this.state.width - 1,
            height: this.state.height - 0.5,
        });
        this._topLevelElements = [];
        this.xAxis.forEach(function (axis) { return axis.beforeRender(); });
        this.yAxis.forEach(function (axis) { return axis.beforeRender(); });
    };
    Grid.prototype.afterRender = function () {
        this.xAxis.forEach(function (axis) { return axis.afterRender(); });
        this.yAxis.forEach(function (axis) { return axis.afterRender(); });
        this._topLevelElements = [];
    };
    Grid.prototype.getEventPlotArea = function () {
        return this._clipPath;
    };
    Grid.prototype.getClipPath = function (offset) {
        if (offset === void 0) { offset = 0; }
        return new Rect({
            x: this.state.left - offset,
            y: this.state.top - offset,
            width: this.state.width + offset * 2,
            height: this.state.height + offset * 2,
            lineWidth: 0,
        });
    };
    Grid.prototype.addToGridTop = function (item) {
        this._topLevelElements.push(item);
    };
    Grid.prototype.renderQuadrant = function () {
        var _a = this.option.quadrant, labels = _a.labels, crosshairs = _a.crosshairs, areaFillColors = _a.areaFillColors;
        var _b = this.state, top = _b.top, left = _b.left, right = _b.right, bottom = _b.bottom, width = _b.width, height = _b.height;
        var textStyle = this.getTextStyle(this.option.quadrant.textStyle);
        var cx = (left + right) / 2;
        var cy = (top + bottom) / 2;
        var group = new Group({
            key: this.getKey('quadrant'),
            pointerEvents: 'none',
        });
        var labelGroup = new Group({
            key: this.getKey('quadrant-labels'),
        });
        var rectGroup = new Group({
            key: this.getKey('quadrant-rects'),
        });
        var margin = 8;
        var sidePosition = {
            top: top + margin,
            left: left + margin,
            right: right - margin,
            bottom: bottom - margin,
        };
        var textPosition = {
            topLeft: ['left', 'top'],
            topRight: ['right', 'top'],
            bottomLeft: ['left', 'bottom'],
            bottomRight: ['right', 'bottom'],
        };
        var areaRectMap = {
            topLeft: { x: left, y: top },
            topRight: { x: cx, y: top },
            bottomLeft: { x: left, y: cy },
            bottomRight: { x: cx, y: cy },
        };
        ['topLeft', 'topRight', 'bottomLeft', 'bottomRight'].forEach(function (position) {
            var label = labels[position];
            var fill = areaFillColors[position];
            var _a = textPosition[position], xside = _a[0], yside = _a[1];
            var x = sidePosition[xside];
            var y = sidePosition[yside];
            if (!lodash.isNull(label) || lodash.isUndefined(label)) {
                labelGroup.add(createText(__assign(__assign({ key: position, text: label, x: x,
                    y: y }, textStyle), { textAlign: xside === 'left' ? 'left' : 'right', textBaseline: yside === 'top' ? 'top' : 'bottom' })));
            }
            if (fill) {
                rectGroup.add(new Rect(__assign(__assign({}, areaRectMap[position]), { width: width / 2, height: height / 2, fill: fill })));
            }
        });
        group.add(rectGroup);
        group.add(labelGroup);
        if (crosshairs) {
            var crossharisGroup = new Group(__assign({ key: this.getKey('crosshairs') }, crosshairs.lineStyle));
            crossharisGroup.add(new Line({
                x1: cx,
                x2: cx,
                y1: top,
                y2: bottom,
            }));
            crossharisGroup.add(new Line({
                x1: left,
                x2: right,
                y1: cy,
                y2: cy,
            }));
            group.add(crossharisGroup);
        }
        return group;
    };
    Grid.prototype.render = function () {
        var _a = this.option, background = _a.background, quadrant = _a.quadrant;
        var group = new Group({
            key: this.getKey('grid'),
        });
        if (this.getDependentSeries().length === 0) {
            return group;
        }
        var _b = this.state, top = _b.top, left = _b.left, width = _b.width, height = _b.height;
        var gridBackgroundRect = new Rect({
            key: this.getKey('bg'),
            x: left,
            y: top,
            width: width,
            height: height,
            fill: background,
            pointerEvents: 'none',
        });
        group.add(gridBackgroundRect);
        this.xAxis.forEach(function (axis) { return group.add(renderModel(axis)); });
        this.yAxis.forEach(function (axis) { return group.add(renderModel(axis)); });
        this._topLevelElements.forEach(function (item) { return group.add(item); });
        if (quadrant) {
            group.add(this.renderQuadrant());
        }
        return group;
    };
    Grid.prototype.beforeDestroy = function () {
        this.chart.getRenderInstance().removeEventElement(this._clipPath);
        if (this.xAxis) {
            this.xAxis.forEach(function (axis) { return axis.destroy(); });
        }
        if (this.yAxis) {
            this.yAxis.forEach(function (axis) { return axis.destroy(); });
        }
    };
    return Grid;
}(ComponentModel));
export default Grid;
